import {
  countryFlagEmoji,
  formatCoarseLocation,
  formatCoarseLocationShort,
  type CoarseLocation,
} from "../features/location/coarseLocation";

export function LocationLabel({
  location,
  className,
  compact = false,
}: {
  location: CoarseLocation | null | undefined;
  className?: string;
  compact?: boolean;
}) {
  if (!location) return null;
  return (
    <span className={className}>
      <span aria-hidden="true">{countryFlagEmoji(location.countryCode)}</span>
      {compact
        ? formatCoarseLocationShort(location)
        : formatCoarseLocation(location)}
    </span>
  );
}
